// stores/useRolePlayStore.ts
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface AppVersionState {
  appVersion: string | null
  setAppVersion: (version: string) => void
}

export const MIN_VERSION = '9.1.3'

// export const useAppVersionStore = create<AppVersionState>((set) => ({
//   appVersion: null,
//   setAppVersion: (version) =>
//     set(() => ({
//       appVersion: version,
//       // isOkToUse: compareVersions(version, MIN_VERSION) >= 0,
//     })),
// }))

export const useAppVersionStore = create<AppVersionState>()(
  persist(
    (set) => ({
      appVersion: null,
      setAppVersion: (version) => set({ appVersion: version }),
    }),
    {
      name: 'app-version-storage', // localStorage에 저장될 key 이름
      // serialize/deserialize 커스터마이징도 가능
    }
  )
)
